import { createReducer } from '@reduxjs/toolkit'
import {
  TDefaultOrganizationalUnit,
  TOrganizationalUnit
} from 'types/GlobalOrganizationalUnit'
import { arrayToObject } from 'utils/functions'

import * as actions from '../../actions/OrganizationalUnits/actions'
import * as authenticationActions from '../../actions/Authentication/actions'

export type OrganizationalUnitsState = {
  data: { [id: string]: TOrganizationalUnit }
  default: TDefaultOrganizationalUnit[]
  fullAccessEnum: string
  fetching: boolean
  fetched: boolean
}

const INITIAL_STATE: OrganizationalUnitsState = {
  data: {},
  default: [],
  fullAccessEnum: 'FULL_ACCESS',
  fetching: false,
  fetched: false
}

const organizationalUnitsReducer = createReducer(INITIAL_STATE, (builder) => {
  builder
    .addCase(actions.getAll, (state) => {
      return {
        ...state,
        fetching: true
      }
    })
    .addCase(actions.getAllSuccess, (state, action) => {
      const { payload } = action

      return {
        ...state,
        data: arrayToObject(payload.customers),
        default: payload.default,
        fullAccessEnum: payload.full_access_enum,
        fetching: false,
        fetched: true
      }
    })
    .addCase(actions.getAllFailed, (state) => {
      return {
        ...state,
        fetching: false
      }
    })
    .addCase(actions.createSuccess, (state, action) => {
      const { payload } = action

      return {
        ...state,
        data: {
          ...state.data,
          [payload.id]: payload
        },
        fetching: false
      }
    })
    .addCase(actions.updateSuccess, (state, action) => {
      const { payload } = action

      return {
        ...state,
        data: {
          ...state.data,
          [payload.id]: payload
        },
        fetching: false
      }
    })
    .addCase(actions.destroySuccess, (state, action) => {
      const { payload } = action
      const newData = { ...state.data }

      delete newData[payload]

      return {
        ...state,
        data: newData,
        fetching: false
      }
    })
    .addCase(authenticationActions.signOut, () => INITIAL_STATE)
    .addDefaultCase((state) => state)
})

export default organizationalUnitsReducer
